import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import { collarProductIsSupportedInCountry, useLocale } from '../../contexts/LocaleContext';
import { getFiGrowthBook } from '../../lib/growthbook';
import * as types from '../../types';
import { ultraCollarId } from '../../types';

export default function useUltraExperienceGuard(): boolean {
  const history = useHistory();
  const { country } = useLocale();
  const internalTester = useSelector((state: types.AppState) => !!state.config.siteConfig.internalTester);

  const [featuresLoaded, setFeaturesLoaded] = useState(false);
  useEffect(() => {
    let cancelled = false;
    getFiGrowthBook()
      .loadFeatures()
      .then(() => {
        if (!cancelled) setFeaturesLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const isUltraSupportedInCountry =
    featuresLoaded && collarProductIsSupportedInCountry(ultraCollarId, country, internalTester);

  useEffect(() => {
    if (featuresLoaded && !isUltraSupportedInCountry) {
      history.replace(AppPaths.Products('smart-collar-v3b'));
    }
  }, [featuresLoaded, isUltraSupportedInCountry, history]);

  return isUltraSupportedInCountry;
}
